// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-button{position:fixed;width:80px;height:80px;border-radius:50%;right:48px;bottom:48px;display:flex;align-items:center;justify-content:center;z-index:1;cursor:pointer;box-shadow:0px 0px 15px rgba(0,0,0,.1019607843);background-color:#f0f2f4}.scroll-button img{width:16px;height:24px}.scroll-button :hover{cursor:pointer}@media only screen and (max-width: 767px){.scroll-button{right:24px;bottom:24px}}", ""]);
// Exports
module.exports = exports;
